// extracted by mini-css-extract-plugin
export var container = "_jz-0";
export var dotAnimation = "_jz-2";
export var dotsLoading = "_jz-1";